<template>
  <div>
    <b-modal :id="'modal-edit-ref-' + refDef.name" ref="editModal" size="xl"  :disabled='saveInProgress' @ok="handleEditOk" no-close-on-backdrop>
      <template  #modal-title>
        <div v-if="isNew">
        Create new Ref of type "{{refDef.name}}"
        </div>
        <div v-else>
        <b-button v-if="hasPrevious" :disabled='saveInProgress' title="Previous" @click="previousItem"><b-icon icon="arrow-left-circle-fill" /></b-button>
        Edit Ref {{selectedItem.customerRefId}} of type "{{refDef.name}}" ({{itemIndex + 1}} of {{totalItems}})
        <b-button v-if="hasNext" :disabled='saveInProgress' title="Next" @click="nextItem"><b-icon icon="arrow-right-circle-fill" /></b-button>
        </div>
        <div v-if="saveResult">
          <b-alert class="mt-1"  variant="danger" :show="!saveResult.success" >{{ saveResult.message }}</b-alert>
        </div>
      </template>
      <edit-item v-bind:simple-properties="itemProperties" ></edit-item>
    </b-modal>
    <b-modal :id="'modal-confirm-delete-ref-' + this.refDef.name" ref="confirmModal" size="xl" :title="'Delete Item '"  @ok="deleteItem">
      <confirm-delete :item="selectedItem"></confirm-delete>
    </b-modal>
    <div>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <p v-if="saveResult">{{ saveResult.message }}</p>
        <b-progress
          variant="success"
          :max="dismissSecs"
          :value="dismissCountDown"
          height="4px"
        ></b-progress>
      </b-alert>
      <b-table hover :items="items" :fields="fields" striped small bordered responsive="sm" class="m-2">
        <template #thead-top="data">
          <b-tr>
            <b-th class="align-middle"> <b-button title="Add Item" @click="addItem"><b-icon-plus></b-icon-plus></b-button></b-th>
            <b-th class="align-middle" :colspan="fields.length -1">
              <b-pagination
              @change="handlePageChange"
              v-model="page"
              :total-rows="count"
              :per-page="pageSize"
            ></b-pagination></b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="row">
         <b-td>
           <b-button-group vertical>
              <b-button v-if="isAdmin || ownEntry(row.item)" title="Edit Item" @click="editItem(row.index,row.item)">
                <b-icon icon="pencil" aria-hidden="true"></b-icon>
              </b-button>
              <b-button v-if="isAdmin" title="Delete Item" @click="confirmDelete(row.item)">
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </b-button>
           </b-button-group>
         </b-td>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import {BackendApiService} from '../../services/BackendApiService'
import EditItem from './EditItem'
import ConfirmDelete from './ConfirmDelete'
// eslint-disable-next-line no-unused-vars
import TextInput from './TextInput'
// eslint-disable-next-line no-unused-vars
import EnumInput from './EnumInput'

export default {

  name: 'RefTable',
  props: ['schema', 'refDef'],
  methods: {
    getRequestParams (page, pageSize) {
      let params = {}

      if (page) {
        params['page'] = page - 1
      }

      if (pageSize) {
        params['size'] = pageSize
      }

      return params
    },
    retrieveItems () {
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      )

      BackendApiService.getRefsByName(this.schema.id, this.refDef.name, params)
        .then((response) => {
          const {items, totalItems} = response.data
          this.items = items.map((item) => {
            let flattenedItem = item
            flattenedItem.properties.forEach((prop) => {
              flattenedItem[prop.fieldName] = prop.value
            })
            flattenedItem['id'] = item.id
            return flattenedItem
          })
          this.count = totalItems
          this.totalItems = totalItems
        })
        .catch((e) => {
          console.log(e)
        })
    },
    confirmDelete (item) {
      this.selectedItem = item
      this.$bvModal.show('modal-confirm-delete-ref-' + this.refDef.name)
    },
    deleteItem () {
      BackendApiService.deleteRef(this.selectedItem.id).then((response) => {
        this.retrieveItems()
        this.$store.state.update++
      })
    },
    addItem () {
      this.selectedItem = null
      this.itemIndex = -1
      this.prepareItemProperties()
      // Show the modal
      this.$bvModal.show('modal-edit-ref-' + this.refDef.name)
    },
    editItem (index, item) {
      this.selectedItem = item
      this.saveResult = null
      this.itemIndex = index
      this.prepareItemProperties()
      // Show the modal
      this.$bvModal.show('modal-edit-ref-' + this.refDef.name)
    },
    ownEntry (item) {
      return item.owner.userID === this.$store.getters.username;
    },
    saveChanges (callback) {
	  this.saveInProgress = true;
      this.saveResult = null
      this.saving = true
      let itemProps = Object.fromEntries(this.itemProperties.map((itemProp) => [itemProp.definition.name, itemProp.value]))
      let itemId = this.isNew ? 'new' : this.selectedItem.id
      return BackendApiService.saveRef(this.schema.id, this.refDef.name, itemId, itemProps).then((response) => {
        console.log('received response on save ', response)
        this.saveResult = response.data
        this.showAlert()
        this.retrieveItems()
      }).catch((error) => {
        if (error.response) {
          console.log('received error with response on save  ', error.response)
          this.saveResult = error.response.data
          return error.response.data
        } else {
          console.log('received error without response on save')
          this.saveResult = {success: false, message: error.message, modified: false}
          return this.saveResult
        }
      }).then(() => {
        this.saving = false
		this.saveInProgress = false;
        if (callback) {
          callback(this.saveResult)
        }
      })
    },
    handleEditOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.saveChanges((response) => {
        if (response.success) {
          this.$bvModal.hide('modal-edit-ref-' + this.refDef.name)
        }
      })
    },
    previousItem () {
      this.saveChanges().then((response) => {
        if (response.success) {
          this.itemIndex = this.itemIndex - 1
          console.log('previous item index', this.itemIndex)
          console.log('prvious current page', this.page)
          if (this.itemIndex < this.pageSize * (this.page - 1)) {
            this.handlePageChange(this.page - 1)
          }
          this.selectedItem = this.items[this.itemIndex - this.pageSize * (this.page - 1)]
          this.prepareItemProperties()
        } else {
          console.log('save on previous failed')
        }
      })
    },
    nextItem () {
      this.saveChanges().then((response) => {
        this.itemIndex = this.itemIndex + 1
        if (this.itemIndex >= this.pageSize * this.page) {
          this.handlePageChange(this.page + 1)
        }
        this.selectedItem = this.items[this.itemIndex - this.pageSize * (this.page - 1)]
        this.prepareItemProperties()
      })
    },
    createItemPropertyForPropDefinition (propDef) {
      let result = {component: 'TextInput', definition: propDef, value: null, options: []}
      if (propDef.enum) {
        let mappedOptions = propDef.validOptions.map((value) => [value, value])
        mappedOptions.forEach((key, value) => {
          result.options.push(key[0])
        })
        result.component = 'EnumInput'
      }
      if (this.selectedItem) {
        let props = this.selectedItem.properties.filter((prop) => {
          if (prop.fieldName === propDef.name) return prop
        })

        if (props.length > 0) {
          result.value = props[0].value
        }
      }
      return result
    },
    prepareItemProperties () {
      var newItemProperties = []
      let customerIdProp = {component: 'TextInput', definition: {name: 'customerId', title: 'Ref ID', description: 'The ref ID'}, value: null, options: [], readonly: true}
      let ownerProp = {component: 'TextInput', definition: {name: 'owner', title: 'Owner', description: 'The owner'}, value: null, options: [], readonly: true}
      let companyIdProp = {component: 'TextInput', definition: {name: 'companyId', title: 'Company ID', description: 'The company ID'}, value: null, options: [], readonly: false}
      if (this.isNew) {
        customerIdProp.readonly = false
      }
      if (this.selectedItem) {
        customerIdProp.value = this.selectedItem.customerRefId
        ownerProp.value = this.selectedItem.owner.userID
        companyIdProp.value = this.selectedItem.companyId
      }
      newItemProperties.push(customerIdProp)
      newItemProperties.push(ownerProp)
      newItemProperties.push(companyIdProp)
      this.refDef.itemProperties.forEach((propDef) => {
        let itemProp = this.createItemPropertyForPropDefinition(propDef)
        newItemProperties.push(itemProp)
      })
      this.itemProperties = newItemProperties
    },
    handlePageChange (value) {
      console.log('changing page to ', value)
      this.page = value
      this.retrieveItems()
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  components: {
    EditItem, ConfirmDelete
  },
  data () {
    return {
      page: 1,
      count: 0,
      pageSize: 10,
      items: [],
      refs: {},
      selectedItem: {},
      itemIndex: 0,
      totalItems: 0,
      itemProperties: [],
      saveResult: null,
      dismissSecs: 3,
      dismissCountDown: 0,
      showDismissibleAlert: false,
	  saveInProgress: false
    }
  },
  computed: {
    fields () {
      this.retrieveItems()
      let result = [{key: 'actions', label: ''}, {key: 'customerRefId', label: 'Ref ID'}, {key: 'owner.userID', label: 'Owner'}, {key: 'companyId', label: 'Company ID'}]
      this.refDef.itemProperties.forEach((value, index) => {
        result.push({key: value.name, label: value.title})
      })
      result.push()
      return result
    },
    hasPrevious () {
      return this.itemIndex > 0
    },
    computedItemProperties () {
      return this.itemProperties
    },
    hasNext () {
      return this.itemIndex < this.totalItems - 1
    },
    isNew () {
      return this.selectedItem == null
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  watch: {
    '$store.state.refUpdate': {
      handler: function () {
        this.retrieveItems()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/RefTable.vue